import { RELATIONSHIP } from "../../../constants/relationship";
import { Member } from "../../../types/employee.types";
import { EnrollmentSchema } from "../../../types/enrollment.types";
import { CoverageType } from "../../../types/plan.types";
import calculateAge from "../age";

export const getCoveredDependents = (coverage: CoverageType): string[] => {
	const coveredDependents: string[] = [];
	if (coverage.ES.active === true) {
		coveredDependents.push(RELATIONSHIP.spouse);
	}
	if (coverage.EC.active === true) {
		coveredDependents.push(RELATIONSHIP.child);
		coveredDependents.push(RELATIONSHIP.stepchild);
		coveredDependents.push(RELATIONSHIP.court_ordered_dependent);
	}
	return coveredDependents;
};

type GroupEligibleDependents = {
	eligibleDependents: Member[];
	ineligibleRelationshipDependents: Member[];
	ineligibleDependents: Member[];
};

export const fullDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

export const getHealthPlanEligibleDependents = (
	dependents: Member[],
	coverage: CoverageType
): GroupEligibleDependents => {
	const coveredDependents = getCoveredDependents(coverage);
	// console.log("Covered Depednets", coveredDependents);

	const eligibleDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	const ineligibleRelationshipDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		// const otherDate = new Date("2023-05-01");
		const age = calculateAge(date_of_birth, fullDate);
		// console.log("Age", age);
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				(age < 26 || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		} else {
			if (coveredDependents.includes(relationship as string)) {
				ineligibleDependents.push(dependent);
			} else {
				// debugger;
				ineligibleRelationshipDependents.push(dependent);
			}
		}
	});

	return {
		eligibleDependents,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};

export const getEnrollmentsByCoverage = (
	enrollments: EnrollmentSchema[]
): {
	coveredSpouseEnrollment: EnrollmentSchema | null;
	employeeEnrollment: EnrollmentSchema | null;
	coveredChildrenEnrollments: EnrollmentSchema[];
} => {
	let employeeEnrollment: EnrollmentSchema | null = null;
	let coveredSpouseEnrollment: EnrollmentSchema | null = null;
	const coveredChildrenEnrollments: EnrollmentSchema[] = [];
	enrollments.forEach((enrollment: EnrollmentSchema) => {
		const { member } = enrollment;
		if (member?.relationship === RELATIONSHIP.spouse) {
			coveredSpouseEnrollment = enrollment;
		} else if (enrollment.member_SSN === enrollment.insured_SSN) {
			employeeEnrollment = enrollment;
		} else {
			coveredChildrenEnrollments.push(enrollment);
		}
	});
	return {
		coveredChildrenEnrollments,
		coveredSpouseEnrollment,
		employeeEnrollment
	};
};
export const getClinicCardEligibleDependents = (dependents: Member[], coverage: CoverageType): Member[] => {
	const coveredDependents = [
		RELATIONSHIP.child,
		RELATIONSHIP.spouse,
		RELATIONSHIP.stepchild,
		RELATIONSHIP.court_ordered_dependent
	];

	const eligibleDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		const age = calculateAge(date_of_birth, fullDate);
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				((age < 26 && age >= 8) || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		}
	});

	return eligibleDependents;
};
